import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const MemorableMomentsSC = styled.div`
    padding: 60px 20px;
    margin: 0 auto;
    font-family: system-ui, -apple-system, sans-serif;
     ${NoTextSelectionStyles}

    .membership-title {
        text-align: center;
        margin-bottom: 40px;
        font-size: 24px;
        letter-spacing: 2px;
    }

    .membership-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(440px, 1fr));
        gap: 16px;
    }

    .text-card {
        background: #e9f0e4;
        padding: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .text-card h3 {
        font-size: 20px;
        margin-bottom: 16px;
    }

    .text-card p {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 20px;
    }

    .learn-btn {
        background: #6e8b55;
        color: white;
        border: none;
        padding: 10px 18px;
        font-size: 12px;
        letter-spacing: 1px;
        cursor: pointer;
    }

    .image-card {
        min-height: 320px;
        background-size: cover;
        background-position: center;
        transition: flex 0.5s ease, transform 0.3s ease;
        &.incr_height {
            min-height: 650px;
        }
        &:hover {
            transform: scale(1.02);
        }
    }

    @media (max-width: 768px) {
        padding: 16px 0px;
        margin: unset;
        width: 100%;

        .membership-title {
            text-align: center;
            margin-bottom: 24px;
            font-size: 16px;
            letter-spacing: 1px;
        }

        .membership-grid {
            grid-template-columns: repeat(3, 1fr);
            width: calc(100% - 16px);
            margin: 0px 8px;
            gap: 4px;
        }

        .image-card {
            min-height: 100px;
            &:hover {
                transform: scale(1.02);
            }
        }
    }
`;

export default MemorableMomentsSC;